import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class ApiKeyService {
  constructor(private readonly rest: RestService) {}

  getApiKeys(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/api-key`);
  }

  createApiKey(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/api-key`, payload);
  }

  deleteApiKey(apiKeyId: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/api-key/${apiKeyId}`);
  }
}
